namespace $ {
	export class $shm_hitalama_text_images_file extends $giper_baza_file.with({
		Byte_size: $giper_baza_atom_real,
	}) {}
}
